import { render, staticRenderFns } from "./ExtraField.vue?vue&type=template&id=55f9b706&lang=pug"
import script from "./ExtraField.vue?vue&type=script&lang=js"
export * from "./ExtraField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports